// extracted by mini-css-extract-plugin
export default {"form":"LoginPage_form__3zvy-","links":"LoginPage_links__CkndH"};